import { trpc } from '@/shared/api/trpc';

export const useUpdateAccount = () => {
  const utils = trpc.useUtils();
  return trpc.accounts.update.useMutation({
    onSettled: (row) => {
      utils.accounts.listAllowlist.invalidate();
      utils.accounts.list.invalidate();
      utils.accounts.listForFilters.invalidate();
      if (row?.id) {
        utils.accounts.byId.invalidate({ id: row.id });
      }
    },
  });
};
